import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';

// MUI
import TextField from '@mui/material/TextField';

import SDatePicker from 'components/SDatePicker';

const readOnlyProps = { disableUnderline: true, readOnly: true };

function DateField(props) {
  const {
    date,
    onChange,
    onError,
    onBlur,
    className,
    readOnly,
    allowNever = false,
    allowInvalid,
    id,
    textFieldProps,
    ...otherProps
  } = props;

  const [currentDate, setDate] = useState(date);
  const [renderKey, setRenderKey] = useState(false);

  const stagedDate = useRef();

  useEffect(() => {
    setDate(date);
  }, [date]);

  const showNever = Boolean(allowNever && (!currentDate || currentDate === ''));

  const handleChange = (newDate) => {
    stagedDate.current = null;
    setDate(newDate);
    if (allowInvalid || newDate?.isValid || (allowNever && newDate === null)) {
      stagedDate.current = newDate; // stage date to send it with onBlur if autoOk (auto close on modal select) is on
      onChange?.(newDate);
    }
  };

  const handleBlur = (e) => {
    let returnDate = date;
    if (showNever) {
      // if no date, set to null and force field rerender through renderKey (to keep 'Never' selected)
      if (e && e.target?.value !== '') {
        setRenderKey(!renderKey);
      }
      returnDate = null;
    } else if (allowInvalid || currentDate?.isValid) {
      returnDate = currentDate;
    }
    if (!e && (allowInvalid || stagedDate.current?.isValid)) {
      // if date staged from change, use that
      returnDate = stagedDate.current;
    } else {
      stagedDate.current = null;
      setDate(returnDate);
    }
    onBlur?.(returnDate);
  };

  // const formatNull = (dateToFormat, invalidLabel) => {
  //   if (!dateToFormat) {
  //     return 'Never';
  //   }
  //   return dateToFormat?.toLocaleString() || invalidLabel;
  // };
  return readOnly ? (
    <TextField
      id={id || 'date-field'}
      margin='normal'
      label='Date'
      type='datetime-local'
      value={date}
      InputProps={readOnlyProps}
      classes={{ root: className }}
      {...otherProps}
    />
  ) : (
    <SDatePicker
      key={renderKey}
      id={id || 'date-field'}
      value={!currentDate || currentDate === '' ? null : currentDate}
      onChange={handleChange}
      onError={onError}
      onClose={handleBlur}
      textFieldProps={{
        onBlur: handleBlur,
        placeholder: showNever ? 'Never' : undefined,
        variant: readOnly ? 'standard' : 'filled',
        className,
        margin: 'normal',
        ...textFieldProps,
      }}
      label='Date'
      OpenPickerButtonProps={{
        'aria-label': 'change date',
      }}
      {...otherProps}
    />
  );
}

DateField.propTypes = {
  date: PropTypes.any, // serves as the 'initialValue' if uncontrolled, and 'value' if controlled
  onChange: PropTypes.func, // use if you want a controlled input
  onError: PropTypes.func, // use if you want to pass the date range error to the parent
  onBlur: PropTypes.func, // use if you DON'T want a controlled input (just get value on blur)
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  allowNever: PropTypes.bool, // allow 'never' when no date is selected
  allowInvalid: PropTypes.bool, // will return invalid dates back to your forms, if you for some reason want that 🙃
  textFieldProps: PropTypes.object,
  id: PropTypes.string,
  autoClose: PropTypes.bool,

  // SDatePickerProps ferried here for typechecking
  maxDate: PropTypes.any,
  disableFuture: PropTypes.bool,
  error: PropTypes.any,
  helperText: PropTypes.any,
  label: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default DateField;
